<div class="photos-container">
  <div class="photos-header">
    <div class="photos-header-left">
      <button
        class="photos-count"
        *ngIf="allPhotos.length > 0"
        mat-button
        (click)="openGalleryFromIndex(0)"
        [attr.aria-label]="allPhotos.length + ' ' + (allPhotos.length === 1 ? 'Bild' : 'Bilder') + ' ansehen'"
        title="Galerie öffnen"
      >
        {{ allPhotos.length }} {{ allPhotos.length === 1 ? 'Bild' : 'Bilder' }}
      </button>
    </div>

    <div class="photos-header-right">
      @if (this.authService.currentUserValue) {
        <button mat-flat-button type="button" (click)="openFilePicker()">Bild hochladen</button>
        <input type="file" #fileInput hidden (change)="onFileSelected($event)" />
      }
    </div>
  </div>

  @if (latestPhoto) {
    <div class="photos-wrap">
      <button class="main-photo" type="button" (click)="openGalleryFromIndex(0)" aria-label="Hauptbild öffnen">
        <img
          [src]="environment.backend + latestPhoto.url"
          alt="Aktuellstes Reststop-Bild"
          loading="lazy"
          decoding="async"
        />
      </button>

      @if (thumbnails.length > 0) {
        <div class="thumbs">
          @for (picture of thumbnails; track picture.id; let i = $index) {
            <button class="thumb" type="button" (click)="openGalleryFromIndex(i + 1)" aria-label="Bild öffnen">
              <img [src]="environment.backend + picture.url" alt="Reststopbild" loading="lazy" decoding="async" />
            </button>
          }
        </div>
      }
    </div>
  } @else {
    <div class="no-photos"> Noch keine Bilder vorhanden. </div>
  }
</div>

@if (isGalleryOpen) {
  <div
    #lightboxRoot
    id="lightbox-root"
    class="lightbox"
    tabindex="0"
    role="dialog"
    aria-label="Bildgalerie"
    (keydown)="onLightboxKey($event)"
    (click)="closeGallery()"
  >
    <div
      class="lightbox-content"
      (click)="$event.stopPropagation()"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd($event)"
    >
      <button class="lightbox-close" type="button" (click)="closeGallery()" aria-label="Schließen">×</button>
      <button class="lightbox-nav prev" type="button" (click)="prev()" aria-label="Vorheriges Bild">
        <span aria-hidden="true">‹</span>
      </button>
      <img
        class="lightbox-img"
        [src]="environment.backend + allPhotos[galleryIndex].url"
        alt="Galeriebild"
        draggable="false"
      />
      <button class="lightbox-nav next" type="button" (click)="next()" aria-label="Nächstes Bild">
        <span aria-hidden="true">›</span>
      </button>
      <div class="lightbox-counter">{{ galleryIndex + 1 }} / {{ allPhotos.length }}</div>
    </div>
  </div>
}
